import { Injectable, signal, Signal, WritableSignal } from "@angular/core";
import { Where } from "../models/table-list-request.interface";
import { Router } from "@angular/router";
import { TosTableService } from "./tos-table.service";
import {ActivityLogSearchBarConfig} from "../components/header/config/search-bar.config"
import { config } from "rxjs";
import { SearchBarKey } from "../components/header/header.component";
import { filter } from "rxjs/operators";
import { FilterCondition } from "../models/advanced-filter.interface";
import { DynamicForm, FormRow } from "../models/dynamic-form";
import { ActivityLogQueryParams, ActivityLogSearchBar } from "../models/activity-log-search.intercafe";

export const FILTER_QUERY_PARAM_KEY = "filter";

@Injectable({
  providedIn: "root"
})
export class HeaderService {
  searchBarConfig: ActivityLogSearchBar = ActivityLogSearchBarConfig;

  constructor(private router: Router,
              private tosTableService: TosTableService) {
  }

  openUrlInNewTab(relativeUrl: string, preSetFilter?: ActivityLogQueryParams): void {
    const queryParams = preSetFilter
      ? { [FILTER_QUERY_PARAM_KEY]: JSON.stringify(preSetFilter) }
      : undefined;

    const urlTree = this.router.createUrlTree([relativeUrl], {
      queryParams
    });

    const url = this.router.serializeUrl(urlTree);
    window.open(url, "_blank");
  }

  getRawFiltersWithValuesInjected(preSetFilter: ActivityLogQueryParams) {
    const preSetFilterConfig: Where = { filterConditions: [], expression: "" };

    const preSetFilterCondition: FilterCondition | undefined = this.searchBarConfig[preSetFilter.configName].preSetFilter;
    if (!preSetFilterCondition) {
      console.error(`No preSetFilters found for key: ${preSetFilter.configName}`);
      return { filterConditions: [], expression: "" };
    }

    const filterCondition: FilterCondition = {
      ...preSetFilterCondition,
      value: [preSetFilter.value],
      alias: `${preSetFilterCondition.alias}_PRESET`
    };
    preSetFilterConfig.filterConditions.push(filterCondition);

    preSetFilterConfig.expression = preSetFilterConfig.filterConditions
      .map(cond => `${cond.alias}`)
      .join(" AND ");

    console.log(preSetFilterConfig);
    return preSetFilterConfig;
  }
}
